module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  })]), _vm._v("\n  Gerando o relatório\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22768e1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/_RelatorioLoading.vue
// module id = 1550
// module chunks = 17